// Rule below disabled to avoid cyclic dependencies causing uninitialized imports
// eslint-disable-next-line monorepo/no-internal-import
import {useValueAfterHydration} from '@aboutyou/ui-components/src/hooks/useValueAfterHydration/useValueAfterHydration';
import {useMemo} from 'react';
import {PhoneOS, getOsFromUserAgent} from './getOsFromUserAgent';

function useUserAgent() {
  return useValueAfterHydration(
    () => window.navigator.userAgent || window.navigator.vendor || window.opera,
  );
}

export function useOS(): PhoneOS {
  const UA = useUserAgent();

  return useMemo(() => getOsFromUserAgent(UA), [UA]);
}

export const useIsMacOsSafari = () => {
  return useValueAfterHydration(
    () =>
      /Safari/.test(window.navigator.userAgent) &&
      !/Chrome/.test(window.navigator.userAgent),
  );
};

export const useIsSafariOrFirefox = () => {
  return useValueAfterHydration(
    () =>
      (/Safari/.test(window.navigator.userAgent) ||
        /Firefox/.test(window.navigator.userAgent)) &&
      !/Chrome/.test(window.navigator.userAgent),
  );
};

export const useBrowserVersion = () => {
  return useValueAfterHydration(
    () => window.__DEVICE_DETAILS__?.browserVersion,
  );
};
